import React, { FC } from 'react';

import { Skeleton } from 'components/common/utils';

import styles from '../AccountDetails.module.scss';

const TABLE_SKELETON_ROWS = 5;

export const AccountDetailsLoading: FC = () => (
  <div className={styles.container} aria-busy="true" aria-live="polite">
    <Skeleton className={styles.skeletonBreadcrumbs} height={16} width={180} borderRadius={4} />

    <Skeleton className={styles.skeletonHeaderCard} height={192} borderRadius={12} />

    <Skeleton className={styles.skeletonStatsCard} height={96} borderRadius={12} />

    <div className={styles.skeletonFiltersBar}>
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton
          key={index}
          className={styles.skeletonFilterPill}
          height={38}
          width={120}
          borderRadius={100}
        />
      ))}
    </div>

    <div className={styles.tableCard}>
      <Skeleton className={styles.skeletonTableHeader} height={48} borderRadius={0} />
      <div className={styles.tableSkeleton}>
        {Array.from({ length: TABLE_SKELETON_ROWS }).map((_, index) => (
          <Skeleton key={index} className={styles.tableSkeletonRow} height={72} borderRadius={0} />
        ))}
      </div>
    </div>
  </div>
);
